import { useState, useEffect, useRef } from 'react';

export const useVoiceRecording = (setInput) => {
  const [isRecording, setIsRecording] = useState(false);
  const recognitionRef = useRef(null);

  useEffect(() => {
    const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
    if (SpeechRecognition) {
      recognitionRef.current = new SpeechRecognition();
      recognitionRef.current.continuous = false;
      recognitionRef.current.interimResults = false;
      recognitionRef.current.onresult = (event) => setInput(prev => prev + (prev ? ' ' : '') + event.results[0][0].transcript);
      recognitionRef.current.onerror = () => setIsRecording(false);
      recognitionRef.current.onend = () => setIsRecording(false);
    }
  }, [setInput]);

  const toggleRecording = () => {
    if (!recognitionRef.current) return;
    if (isRecording) {
      recognitionRef.current.stop();
      setIsRecording(false);
    } else {
      try { recognitionRef.current.start(); setIsRecording(true); } 
      catch (e) {
        console.error('Speech recognition error:', e);
        setIsRecording(false);
      }
    }
  };

  return { isRecording, toggleRecording };
};
